import { createReducer } from "@reduxjs/toolkit";
import type { RetrievalState } from "@redux/state/shared-types";
import {
  retrieveEducationalAdvisorStudentByEmail,
  resetRetrieveEducationalAdvisorStudentByEmail,
} from "./retrieve-educational-advisor-student-by-email";
import type { BatchStudent } from "@shared-kernel/application/ports/educational-advisor/educational-advisor-repository";
import type { Nullable } from "@shared-kernel/core/types/nullable";

const initialState: RetrievalState<Nullable<BatchStudent>> = { fetching: "idle", data: null };

export const retrieveEducationalAdvisorStudentByEmailReducer = createReducer<RetrievalState<Nullable<BatchStudent>>>(
  initialState,
  builder => {
    builder.addCase(retrieveEducationalAdvisorStudentByEmail.fulfilled, (state, { payload }) => {
      return {
        ...state,
        data: payload,
        fetching: "success",
      };
    });
    builder.addCase(retrieveEducationalAdvisorStudentByEmail.pending, state => {
      return {
        ...state,
        fetching: "pending",
      };
    });
    builder.addCase(retrieveEducationalAdvisorStudentByEmail.rejected, state => {
      return {
        ...state,
        data: null,
        fetching: "failed",
      };
    });
    builder.addCase(resetRetrieveEducationalAdvisorStudentByEmail, () => {
      return initialState;
    });
  },
);
